import { render, staticRenderFns } from "./gift-list.vue?vue&type=template&id=1bddf93f&"
import script from "./gift-list.vue?vue&type=script&lang=js&"
export * from "./gift-list.vue?vue&type=script&lang=js&"
import style0 from "./gift-list.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports